import { Box, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";

const NumberCircle = ({ number, sx = {} }) => {
  const colors = useColors();

  return (
    <Box
      sx={{
        border: "1px solid " + colors.primary_light,
        borderRadius: "50%",
        width: "18px",
        height: "18px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...sx, // Spread additional styles
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: colors.primary_main,
        }}
      >
        {number}
      </Typography>
    </Box>
  );
};

export default NumberCircle;
